@let model = viewModel();

<article class="hd-gate-line" [class.hd-gate-line--transit-only]="isTransitOnlyLine()">
  <header class="hd-gate-line__header">
    <div class="hd-gate-line__number-col">
      <div class="hd-gate-line__number" [class.hd-gate-line__number--dim]="model.inactiveInChart">{{ model.lineNumber }}</div>
      <div class="hd-gate-line__gate-line">{{ model.gateLineLabel }}</div>
    </div>

    <div class="hd-gate-line__heading">
      @if (model.keynote) {
        <div class="hd-gate-line__keynote">
          <span>{{ model.keynote }}</span>
          @if (lineCompanionVisible()) {
            <!-- Line Companion (community-content): opent de boektekst van deze
                 poort, automatisch gescrold naar deze lijn. -->
            <button
              type="button"
              class="hd-gate-line__lc-button"
              [title]="lineCompanionLabel()"
              [attr.aria-label]="lineCompanionLabel()"
              (click)="openLineCompanion($event)"
            >
              <i class="fa-regular fa-book-open-lines" aria-hidden="true"></i>
            </button>
          }
          @if (classicIChingVisible()) {
            <!-- Classic I Ching: klassieke tekst van hexagram = poort, gescrold
                 naar deze lijn. -->
            <button
              type="button"
              class="hd-gate-line__lc-button hd-gate-line__iching-button"
              [title]="classicIChingLabel()"
              [attr.aria-label]="classicIChingLabel()"
              (click)="openClassicIChing($event)"
            >
              <i class="fa-regular fa-scroll-old" aria-hidden="true"></i>
            </button>
          }
        </div>
      }
      @if (model.roleKeynote) {
        <div class="hd-gate-line__role-keynote">{{ model.roleKeynote }}</div>
      }
      @if (model.roleKeynote2) {
        <div class="hd-gate-line__role-keynote2">{{ model.roleKeynote2 }}</div>
      }
    </div>

    <div class="hd-gate-line__top-right">
      <div class="hd-gate-line__top-row">
        @if (model.icons.length > 0) {
          <div class="hd-gate-line__icons">
            @for (icon of model.icons; track icon.key) {
              <hd-gate-attribute-icon [gate]="model.gate" [iconKey]="icon.key" [label]="icon.label" />
            }
          </div>
        }
        @if (hasExtra()) {
          <button
            type="button"
            class="hd-gate-line__toggle"
            [class.hd-gate-line__toggle--active]="showExtra()"
            [attr.aria-pressed]="showExtra()"
            [attr.aria-label]="showExtra() ? 'Extra info verbergen' : 'Extra info tonen'"
            [attr.title]="showExtra() ? 'Extra info verbergen' : 'Extra info tonen'"
            (click)="toggleExtra()"
          >
            <i class="fas" [class.fa-eye]="!showExtra()" [class.fa-eye-slash]="showExtra()" aria-hidden="true"></i>
          </button>
        }
      </div>

      @if (model.activations.length > 0) {
        <div class="hd-gate-line__top-row hd-gate-line__top-row--second hd-gate-line__activations">
          @for (act of model.activations; track $index) {
            <span
              class="hd-gate-line__activation"
              [class.is-personality]="act.side === 'personality'"
              [class.is-design]="act.side === 'design'"
              [class.is-transit]="act.origin === 'transit'"
              (mouseenter)="onActivationHover(act)"
              (mouseleave)="onActivationLeave()"
            >
              <span class="hd-gate-line__planet">{{ act.glyphChar }}</span>
              <span class="hd-gate-line__planet-label"
                >{{ act.side === 'design' ? 'D' : 'P' }}-{{ act.planetName }}</span
              >
              @if (act.fixing === 'exaltation' || act.fixing === 'both') {
                <span class="hd-gate-line__fixing hd-gate-line__fixing--exaltation" [class.hd-gate-line__fixing--transit]="act.origin === 'transit'" aria-hidden="true">▲</span>
              }
              @if (act.fixing === 'detriment' || act.fixing === 'both') {
                <span class="hd-gate-line__fixing hd-gate-line__fixing--detriment" [class.hd-gate-line__fixing--transit]="act.origin === 'transit'" aria-hidden="true">▼</span>
              }
              @if (act.transitFixing === 'exaltation' || act.transitFixing === 'both') {
                <span class="hd-gate-line__fixing hd-gate-line__fixing--exaltation hd-gate-line__fixing--transit" aria-hidden="true">▲</span>
              }
              @if (act.transitFixing === 'detriment' || act.transitFixing === 'both') {
                <span class="hd-gate-line__fixing hd-gate-line__fixing--detriment hd-gate-line__fixing--transit" aria-hidden="true">▼</span>
              }
            </span>
          }
        </div>
      } @else if (model.inactiveInChart) {
        <div class="hd-gate-line__top-row hd-gate-line__top-row--second">
          <!-- Informatieve planeet (Chiron): geen activatie, enkel een subtiele markering. -->
          @for (planet of model.informativePlanets ?? []; track $index) {
            <span
              class="hd-gate-line__informative"
              [class.is-design]="planet.side === 'design'"
              [title]="model.informativeLabel"
              data-test-id="gate-line-informative"
            >
              <span class="hd-gate-line__planet">{{ planet.glyphChar }}</span>
              <span class="hd-gate-line__planet-label">{{ planet.side === 'design' ? 'D' : 'P' }}-{{ planet.planetName }}</span>
            </span>
          }
          <i
            class="fa-regular fa-circle-dashed hd-gate-line__no-activation"
            [title]="model.noActivationLabel"
            [attr.aria-label]="model.noActivationLabel"
          ></i>
        </div>
      }
    </div>
  </header>

  <div class="hd-gate-line__body">
    @if (showRa() && showExtra() && model.subText) {
      <p class="hd-gate-line__subtext">{{ model.subText }}</p>
    }
    @if (showRa() && (model.learningAbout || (showExtra() && model.learningAboutExtended))) {
      <p class="hd-gate-line__learning">
        @if (model.learningAbout) {
          <span>{{ model.learningAbout }}</span>
        }
        @if (showExtra() && model.learningAboutExtended) {
          <span class="hd-gate-line__learning-extended"> {{ model.learningAboutExtended }}</span>
        }
      </p>
    }
    @if (showOwn() && model.ownDescription) {
      <!-- Eigen lijnbeschrijving (Mechanics in Motion): ◆ + amber-inkt. -->
      <hd-own-line-text class="hd-gate-line__own" [class.hd-gate-line__own--plain]="!model.learningAbout" [gate]="model.gate" [line]="model.lineNumber" field="description" [text]="model.ownDescription" />
    }
    @if (model.exaltation; as exaltation) {
      <hd-gate-line-duality-row
        [row]="exaltation"
        kind="exaltation"
        [gate]="model.gate"
        [line]="model.lineNumber"
        [showRa]="showRa()"
        [showCustom]="showAlternativeIChing()"
        [showOwn]="showOwn()"
        [emphasis]="exaltationState()"
        [fixationCauseTooltip]="model.exaltationCauseTooltip"
        [fixationOrigins]="model.exaltationFixingOrigins ?? []"
      />
    }
    @if (model.detriment; as detriment) {
      <hd-gate-line-duality-row
        [row]="detriment"
        kind="detriment"
        [gate]="model.gate"
        [line]="model.lineNumber"
        [showRa]="showRa()"
        [showCustom]="showAlternativeIChing()"
        [showOwn]="showOwn()"
        [emphasis]="detrimentState()"
        [fixationCauseTooltip]="model.detrimentCauseTooltip"
        [fixationOrigins]="model.detrimentFixingOrigins ?? []"
      />
    }
  </div>

  @if (model.zodiacStart || model.zodiacEnd) {
    <footer class="hd-gate-line__footer">
      <span class="hd-gate-line__zodiac">{{ model.zodiacStart }} - {{ model.zodiacEnd }}</span>
    </footer>
  }
</article>
